// extracted by mini-css-extract-plugin
export default {"wrapper":"hVK7SvaJqIdhi7hHLPjn","inner":"LGv8otBlM12Xk9d5_cge","icon":"mNSnVwq9XZ9UDDcUdKA8","fadeIn":"BnpJEmvFJm5cOKrvJ_Vo"};